import { apiClient } from './api';
import type {
  ProgressEstimation,
  ProgressEstimationsResponse,
  ProgressEstimationAccuracyResponse,
  CreateProgressEstimationInput,
  ProgressEstimationManagedUser,
  ProgressEstimationManagedUsersResponse,
} from './types';

export class ProgressEstimationService {
  private static readonly ENDPOINT = '/api/progress-estimations';

  static async getEstimations(userId?: number): Promise<ProgressEstimation[]> {
    const query = userId ? `?userId=${userId}` : '';
    const response = await apiClient.get<ProgressEstimationsResponse>(`${this.ENDPOINT}${query}`);
    return response.data.estimations;
  }

  static async generate(input: CreateProgressEstimationInput): Promise<ProgressEstimation> {
    const response = await apiClient.post<ProgressEstimation>(`${this.ENDPOINT}/generate`, input);
    return response.data;
  }

  static async getManagedUsers(): Promise<ProgressEstimationManagedUser[]> {
    const response = await apiClient.get<ProgressEstimationManagedUsersResponse>(`${this.ENDPOINT}/managed-users`);
    return response.data.managed_users;
  }

  static async getAccuracy(windowDays: 30 | 90, userId?: number): Promise<ProgressEstimationAccuracyResponse> {
    const params = new URLSearchParams({ windowDays: String(windowDays) });
    if (userId) {
      params.set('userId', String(userId));
    }

    const response = await apiClient.get<ProgressEstimationAccuracyResponse>(`${this.ENDPOINT}/accuracy?${params.toString()}`);
    return response.data;
  }
}

export default ProgressEstimationService;
